import { forwardRef, type Ref, type SVGProps } from "react";
const IconKitchenFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 2a3 3 0 0 0-3 3v8h20V5a3 3 0 0 0-3-3zm2 5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m15 8H6v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zm-14 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconKitchenFilledSVG);
ForwardRef.displayName = "IconKitchenFilled";
export { ForwardRef as IconKitchenFilled };
